export default __webpack_public_path__ + "static/media/keto_concentration@2x.8923854a.jpg";